import EcoImg from 'eco-design/base/eco-img';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function D1() {
    const { useLang } = useGlobal();
    const { t } = useLang('outdoorrecreation');

    return (
        <div id="outdoor-recreation-D" className={`outdoor-recreation-D1 ${css['outdoor-recreation-D1']}`}>
            <EcoImg
                pc="https://websiteoss.ecoflow.com/figma-uploads/1787715618152-tvdk3c-compressed-003.webp"
                h5="https://websiteoss.ecoflow.com/figma-uploads/1787715468307-kahdtz-compressed-003.webp"
                alt={t('secD_title')}
                aria-label={t('secD_title')}
            />
            <div className="info">
                <p className="title">{t('secD_title')}</p>
                <p className="desc">{t('secD_desc')}</p>
            </div>
        </div>
    );
}
